<template>
  <footer class="invoice-create-footer">
    <div class="invoice-create-footer-left">
      <button type="button" class="app-header-btn app-header-btn--ghost invoice-create-clear-btn" @click="$emit('reset-draft')">
        <i class="fa fa-repeat" aria-hidden="true"></i>
        {{ generalText.common.clear }}
      </button>
    </div>

    <div class="invoice-create-footer-right">
      <button type="button" class="app-header-btn app-header-btn--secondary" @click="$emit('preview')">
        {{ generalText.common.preview }}
      </button>
      <button type="button" class="app-header-btn app-header-btn--success" @click="$emit('submit')">
        <i class="fa fa-file-text-o" aria-hidden="true"></i>
        {{ text.create.ui.footerActions.submit }}
      </button>
    </div>
  </footer>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: invoiceText } = useDomainText('invoices');
const { catalog: generalText } = useDomainText('general');

export default {
  name: 'InvoiceCreateFooterActions',
  emits: ['reset-draft', 'preview', 'submit'],
  data() {
    return {
      text: invoiceText,
      generalText,
    };
  },
};
</script>
